const performanceCookieCategory = '2';

// Look for first link with anchor tag: #onetrust-modal
function initOnetrustLink() {
  try {
    const onetrustLinks = document.querySelectorAll('a[href="#onetrust-modal"]');
    if (onetrustLinks && onetrustLinks.length > 0) {
      onetrustLinks[0].addEventListener('click', function(event) {
        event.preventDefault();
        if (window.Optanon) {
          window.Optanon.ToggleInfoDisplay();
        } else {
          console.warn('Optanon is not defined');
        }
      });
    }
  } catch (error) {
    console.error('Error in initOnetrustLink:', error);
  }
}

// Initiate Onetrust global variable
function waitForOneTrust() {
  try {
    let attempts = 0;
    const interval = setInterval(function() {
      if (hasOneTrustLoaded() || attempts > 100) {
        clearInterval(interval);
      }
      attempts++;
    }, 100);
  } catch (error) {
    console.error('Error in waitForOneTrust:', error);
  }
}

function hasOneTrustLoaded() {
  try {
    if (typeof window.OnetrustActiveGroups === 'string') {
      optanonWrapper();
      window.OptanonWrapper = optanonWrapper;
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error in hasOneTrustLoaded:', error);
    return false;
  }
}

// Set the Shopify tracking consent
function sendConsent(trackingConsent) {
  try {
    const defaultConsent = {
      analytics: trackingConsent,
      marketing: trackingConsent,
      preferences: trackingConsent,
    };

    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(defaultConsent, () => {
        console.log('trackingConsent:', trackingConsent);
        console.log('currentVisitorConsent:', window.Shopify.customerPrivacy.currentVisitorConsent());
				console.log('OptanonActiveGroups', window.OptanonActiveGroups);
        if (window.dataLayer) {
          window.dataLayer.push({
            consent_status: trackingConsent,
          });
        }
      });
    } else {
      console.warn('Shopify Customer Privacy API not available');
    }
  } catch (error) {
    console.error('Error in sendConsent:', error);
  }
}

// Initiate Shopify Consent API
function optanonWrapper() {
  try {
    const trackingConsent = window.OnetrustActiveGroups.includes(performanceCookieCategory);
    window.Shopify.loadFeatures(
      [{
        name: 'consent-tracking-api',
        version: '0.1',
      },],
      (error) => {
        if (error) {
          console.error('Error loading Shopify features:', error);
        } else {
          sendConsent(trackingConsent);
        }
      }
    );
  } catch (error) {
    console.error('Error in optanonWrapper:', error);
  }
}

// Update social media consent
function checkOnConsent(status) {
  try {
    if (status) {
      if (typeof fbq !== 'undefined') fbqPixelConsentManage('grant');
      if (typeof ttq !== 'undefined') ttqPixelConsentManage('grant');
      if (window.dtrum) dynatraceConsentManage(true);
    } else {
      if (typeof fbq !== 'undefined') fbqPixelConsentManage('revoke');
      if (typeof ttq !== 'undefined') ttqPixelConsentManage('revoke');
      if (window.dtrum) dynatraceConsentManage(false);
    }
  } catch (error) {
    console.error('Error in checkOnConsent:', error);
  }
}

// Example pixel consent management functions
function fbqPixelConsentManage(status) {
  try {
    if (typeof fbq !== 'undefined' && (status === 'revoke' || status === 'grant')) {
      window.fbq('consent', status);
      console.log('=> Facebook consent status:', status.toUpperCase());
    }
  } catch (error) {
    console.error('Error in fbqPixelConsentManage:', error);
  }
}

function ttqPixelConsentManage(status) {
  try {
    if (typeof ttq !== 'undefined') {
      if (status === 'revoke') ttq.revokeConsent();
      if (status === 'grant') ttq.grantConsent();
      console.log('=> TikTok consent status:', status.toUpperCase());
    }
  } catch (error) {
    console.error('Error in ttqPixelConsentManage:', error);
  }
}

function dynatraceConsentManage(status) {
  try {
    if (window.dtrum) {
      if (status) {
        window.dtrum.enableSessionReplay(true);
        window.dtrum.enable();
        console.log('=> Dynatrace consent status: ENABLED');
      } else {
        window.dtrum.disableSessionReplay();
        console.log('=> Dynatrace consent status: DISABLED');
      }
    }
  } catch (error) {
    console.error('Error in dynatraceConsentManage:', error);
  }
}

// On initial load, load Shopify Consent Tracking
window.Shopify.loadFeatures(
  [{
    name: 'consent-tracking-api',
    version: '0.1',
  }, ],
  (error) => {
    if (error) {
      console.error('Error loading Shopify Consent API:', error);
    } else {
      try {
        // Check if OnetrustActiveGroups exists before using it
        if (typeof window.OnetrustActiveGroups === 'string' && window.OnetrustActiveGroups) {
          const trackingConsent = window.OnetrustActiveGroups.includes(performanceCookieCategory);
          checkOnConsent(trackingConsent);
        } else {
          console.log('OneTrust not yet loaded, will be handled by waitForOneTrust');
          // Default to no consent until OneTrust loads
          checkOnConsent(false);
        }
      } catch (e) {
        console.error('Error during initial consent load:', e);
      }
    }
  }
);

// DOMContentLoaded event
document.addEventListener('DOMContentLoaded', () => {
  try {
    initOnetrustLink();
    waitForOneTrust();
  } catch (error) {
    console.error('Error in DOMContentLoaded handler:', error);
  }
});
